/* eslint-disable */
'use strict';

var base = require('../product/base');
var focusHelper = require('base/components/focus');
var wishlist = require('../product/wishlist');
var quantityWidgetHelpers = require('../product/quantity');
var util = require('../util');
window.jqueryzoom = window.jqueryZoom = require('jquery-zoom/jquery.zoom.min');
var customerservice = require('../pages/customerservice');
var imagesLoaded = require('imagesloaded');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
            'fade show" role="alert">' +
            '<span class="alert-icon"></span>' + data.valid.message + '</div>';

            $('.cart-error').empty().append(errorHtml);
        } else {
            $('.cart').empty().append('<div class="row"> ' +
                '<div class="col-12 text-center"> ' +
                '<h1>' + data.resources.emptyCartMsg + '</h1> ' +
                '</div> ' +
                '</div>'
            );
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
            window.location.reload(true);
        }

        $('.checkout-btn').addClass('disabled');
        $('.paypal-button').addClass('disabled');
    } else {
        var has3PAddedForNonUSLocale = $('.third-party-not-available').length > 0;

        if (data.has3PProducts & has3PAddedForNonUSLocale) {
            return;
        } else if (!data.has3PProducts && has3PAddedForNonUSLocale) {
            // The cart no longer has 3P products, remove the stale error message
            $('.third-party-not-available').remove();
        }

        $('.checkout-btn').removeClass('disabled');
        $('.paypal-button').removeClass('disabled');
        $('.cart-error').empty();
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.shipping-cost').empty().append(data.totals.totalShippingCost == '$0.00' ? 'Free' : data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax == '$0.00' ? 'TBD' : data.totals.totalTax);
    $('.grand-total').empty().append(data.totals.grandTotal);
    $('.estimated-order-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.sub-total-mobile').empty().append(data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
        if(data.totals.shippingLevelDiscountTotal.formatted == data.totals.totalShippingCost){
            $('.shipping-cost').empty().append('Free');
        }
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    data.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        }
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
    });
    updateYouSavedMsg(data.totals);
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<span class="alert-icon"></span>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center d-flex justify-content-center">'
                +$('.asset-image').html()+'<span class="discount-text">'+ item.discountMsg +'</span>'+ '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

function updateYouSavedMsg(totals) {
    var html = '';
    $('.promotion-information').empty();
    if(totals.totalDiscounts == 0){
        $('.promotion-information').empty();
    }
    if (totals.totalDiscounts != 0 && totals.totalDiscounts != null) {
        if(totals.totalDiscounts.indexOf('-') > -1){
            html += util.svg('you_saved', 'medium') + 'You Saved'
            + ' '+totals.totalDiscounts.split('-')[1];
        } else {
            html += util.svg('you_saved', 'medium') + 'You Saved'
            + totals.totalDiscounts;
        }
    }
    $('.promotion-information').append(html);
}
/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    if(message != 'In Stock'){
                        messages += '<p class="line-item-attributes">' + message + '</p>';
                    }
                });
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) { // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span class="close-icon"></span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    // $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');
            loadZoom();
            if (data.product.readyToOrder) {
                $('.quick-view-dialog .detail-panel .quantity-input').attr('disabled', false);
            }
            // $.spinner().stop();
        },
        error: function () {
            // $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
}

/**
* PDP loadZoom Event
*/
function loadZoom() {
    var imgZoom = '.primary-images .desktop-zoom';
    var container = imgZoom;
    imagesLoaded(container).on('always', function () {
        var $container = $(container);
        $(container).trigger('zoom.destroy');
        $(container).find('.zoomImg').remove();
        $container.zoom();
    });
}

function updateCheckOutTotals(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax == '$0.00' ? 'TBD' : data.totals.totalTax);
    $('.grand-total-sum').empty().append(data.totals.grandTotal);
    $('.estimated-order-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.sub-total-mobile').empty().append(data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
        if(data.totals.shippingLevelDiscountTotal.formatted == data.totals.totalShippingCost){
            $('.shipping-cost').empty().append('Free');
        }
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    data.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        }
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
    });
    updateYouSavedMsg(data.totals);
}

module.exports = function () {

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
    });

    $('.optional-promo').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('.promo-code-form').toggle();
    });

    // Prevent duplicate bindings
    $('body')
    .off('click.cartRemove')
    .on('click.cartRemove', '.cart-delete-confirmation-btn, .remove-product', function (e) {
        e.preventDefault();

        var $btn = $(this);

        // Prevent multiple clicks on the same button
        if ($btn.prop('disabled')) {
            return;
        }
        $btn.prop('disabled', true);

        var productID = $btn.data('pid');
        var url = $btn.data('action');
        var uuid = $btn.data('uuid');
        if (!url || !uuid) {
            console.error('Remove product action missing required parameters.');
            $btn.prop('disabled', false);
            return;
        }

        // Ensure appendToUrl is available
        if (typeof appendToUrl === 'function') {
            url = appendToUrl(url, { pid: productID, uuid: uuid });
        }

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (!data || !data.basket) {
                    console.error('Invalid cart data received.');
                    $btn.prop('disabled', false);
                    return;
                }

                var basket = data.basket;

                if (basket.items.length === 0) {
                    if (window.SiteAccessibility && typeof SiteAccessibility.updatesAnnouncementCart === 'function') {
                        SiteAccessibility.updatesAnnouncementCart('remove', basket.numItems);
                    }

                    $('.cart').html(
                        '<div class="row">' +
                            '<div class="col-12 text-center">' +
                                '<h1>' + basket.resources.emptyCartMsg + '</h1>' +
                            '</div>' +
                        '</div>'
                    );
                    $('.number-of-items').text(basket.resources.numberOfItems);
                    $('.minicart-quantity').text(basket.numItems);
                    $('.minicart-link').attr({
                        'aria-label': basket.resources.minicartCountOfItems,
                        title: basket.resources.minicartCountOfItems
                    });
                    $('.minicart .popover').empty().removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                    location.reload();
                } else {
                    if (Array.isArray(data.toBeDeletedUUIDs)) {
                        data.toBeDeletedUUIDs.forEach(function (delUUID) {
                            $('.uuid-' + delUUID).remove();
                        });
                    }
                    $('.uuid-' + uuid).remove();
                    if (!basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos').html(basket.totals.discountsHtml || '');
                    updateCartTotals(basket);
                    updateApproachingDiscounts(basket.approachingDiscounts || []);
                    $('body').trigger('setShippingMethodSelection', basket);
                    validateBasket(basket);

                    if (window.SiteAccessibility && typeof SiteAccessibility.updatesAnnouncementCart === 'function') {
                        SiteAccessibility.updatesAnnouncementCart('remove', basket.numItems);
                    }
                }

                $('body').trigger('cart:update', data);
                $btn.prop('disabled', false); // Re-enable if needed
            },
            error: function (err) {
                var response = err && err.responseJSON;
                if (response && response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                } else if (response && response.errorMessage) {
                    createErrorNotification(response.errorMessage);
                } else {
                    console.error('Cart remove error', err);
                }
                $btn.prop('disabled', false);
            }
        });
    });

    function updateQuantity($this) {
        var isWishlist = $('.wishlist-dashboard, .guest-wishlist-container').length > 0;

        if (isWishlist) return;

        var preSelectQty = $this.data('pre-select-qty');
        var quantity = $this.val();
        var productID = $this.data('pid');
        var url = $this.data('url');
        var uuid = $this.data('uuid');
        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        var updateUrl = appendToUrl(url, urlParams);
        $('body').trigger('cart:beforeUpdate');
        $.ajax({
            url: updateUrl,
            type: 'get',
            context: $this,
            dataType: 'json',
            success: function (data) {
                $('.quantity-input-widget[data-uuid="' + uuid + '"]').val(quantity);
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                $this.data('pre-select-qty', quantity);

                $('body').trigger('cart:update', data);

                // $.spinner().stop();
                if ($this.parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                    location.reload();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $this.val(parseInt(preSelectQty, 10));
                    // $.spinner().stop();
                }
            }
        });
    }

    var debouncedCallback = quantityWidgetHelpers.getDebouncedFn(updateQuantity);

    $('body').on('change', '.quantity-widget-wrapper .quantity-input-widget', function (e) {
        e.preventDefault();
        var $this = $(this);
        var $productContainer = $this.closest('.quantity-widget-wrapper');
        var quantity = quantityWidgetHelpers.getCurrentQuantity(this);
        var maxQuantity = quantityWidgetHelpers.getMaxQuantity(this);
    
        if (quantity < 1) {
          quantityWidgetHelpers.setQuantiy($this, 1);
        }
    
        quantityWidgetHelpers.updateQuantityButtonsAndError($productContainer, function() {
            var hasQuantityError =  $this.closest('.product-info').find('.quantity-error.d-block').length > 0;
            var otherErrors = $('.third-party-not-available').length > 0;
            return hasQuantityError || otherErrors;
        }, $this.closest('.product-info'), $('.checkout-continue a'));
    
        if (quantity <= maxQuantity) {
            debouncedCallback($this);
        }
    });

    $('body').on('keydown', '.quantity-widget-wrapper .quantity-input-widget', function (e) {
        quantityWidgetHelpers.preventInvalidInput(e);
    });

    $('body').on('blur', '.quantity-widget-wrapper .quantity-input-widget', function (e) {
        var $this = $(this);
        quantityWidgetHelpers.resetOnBlur($this);
    });

    // Attach quantity handlers only once
    function attachQuantityHandlers() {
        var $body = $('body');

        // Clear previous bindings to avoid duplicate triggers
        $body.off('click.quantityIncrease')
            .off('click.quantityDecrease');

        // Increase Quantity
        $body.on('click.quantityIncrease', '.quantity-widget-wrapper .quantity-widget-increase', function (e) {
            e.preventDefault();
            var $btn = $(this);
            if ($btn.hasClass('disabled-btn')) return;

            var $wrapper = $btn.closest('.quantity-widget-wrapper');
            var $input = $wrapper.find('.quantity-input-widget');

            var step = quantityWidgetHelpers.getStep($input);
            var maxQuantity = quantityWidgetHelpers.getMaxQuantity($input);
            var currentQuantity = quantityWidgetHelpers.getCurrentQuantity($input);

            if (currentQuantity < maxQuantity) {
                var newQuantity = currentQuantity + step;
                quantityWidgetHelpers.setQuantiy($input, newQuantity);
                debouncedCallback($input);
            }
            quantityWidgetHelpers.updateQuantityButtonsAndError(
                $wrapper,
                function () {
                    var hasError = $btn.closest('.product-info').find('.quantity-error.d-block').length > 0;
                    var otherErrors = $('.third-party-not-available').length > 0;
                    return hasError || otherErrors;
                },
                $input.closest('.product-info'),
                $('.checkout-continue a')
            );
        });

        // Decrease Quantity
        $body.on('click.quantityDecrease', '.quantity-widget-wrapper .quantity-widget-decrease', function (e) {
            e.preventDefault();
            var $btn = $(this);
            if ($btn.hasClass('disabled-btn')) return;

            var $wrapper = $btn.closest('.quantity-widget-wrapper');
            var $input = $wrapper.find('.quantity-input-widget');

            var step = quantityWidgetHelpers.getStep($input);
            var maxQuantity = quantityWidgetHelpers.getMaxQuantity($input);
            var currentQuantity = quantityWidgetHelpers.getCurrentQuantity($input);

            if (currentQuantity > 1) {
                var newQuantity = currentQuantity - step;
                quantityWidgetHelpers.setQuantiy($input, newQuantity);
            }

            if (currentQuantity - step <= maxQuantity) {
                debouncedCallback($input);
            }
            
            quantityWidgetHelpers.updateQuantityButtonsAndError(
                $wrapper,
                function () {
                    var hasError = $btn.closest('.product-info').find('.quantity-error.d-block').length > 0;
                    var otherErrors = $('.third-party-not-available').length > 0;
                    return hasError || otherErrors;
                },
                $input.closest('.product-info'),
                $('.checkout-continue a')
            );
        });
    }

    // Call this only ONCE when page loads or cart is refreshed
    attachQuantityHandlers();

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        // $('.totals').spinner().start();
        $('body').trigger('cart:beforeShippingMethodSelected');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                }

                $('body').trigger('cart:shippingMethodSelected', data);
                // $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    // $.spinner().stop();
                }
            }
        });
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        // $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            // $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                }
                $('.coupon-code-field').val('');
                // $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    // $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $deleteCheckoutConfirmBtn = $('.delete-checkout-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);
        $deleteCheckoutConfirmBtn.data('uuid', uuid);
        $deleteCheckoutConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        // $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                // $.spinner().stop();
                $('body').trigger('promotion:success', data);
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    // $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        // $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                // $.spinner().stop();
            },
            error: function () {
                // $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-input'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        $('.update-cart-product-global', dialog).attr('disabled',
            !$('.global-availability', dialog).data('ready-to-order')
            || !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty();

        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('quantity:update', function() {
        var selectedQuantity = $('.quantity-input').val();
        if (!selectedQuantity) {
            selectedQuantity = $('.quantity-input-widget').val();
        }
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
        };

        // $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);

                    // $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        // $.spinner().stop();
                    }
                }
            });
        }
    });

    $('body').on('click', '.delete-checkout-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        // $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                updateCheckOutTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                // $.spinner().stop();
                $('body').trigger('promotion:success', data);
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    // $.spinner().stop();
                }
            }
        });
    });

    $('body').on('click', '.promo-code-btn-checkout', function (e) {
        e.preventDefault();
        // $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form-checkout .form-control').addClass('is-invalid');
            $('.promo-code-form-checkout .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').removeClass('hidden');
            $('.coupon-missing-error').show();
            // $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form-checkout');
        $('.promo-code-form-checkout .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');
        var data = "couponCode="+ $('.coupon-code-field').val() + "&csrf_token=" + $('[name="csrf_token"]').val();
    
        $.ajax({
            url: $form.attr('data-url'),
            type: 'GET',
            dataType: 'json',
            data: data,
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form-checkout .form-control').addClass('is-invalid');
                    $('.promo-code-form-checkout .form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCheckOutTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                }
                $('.coupon-code-field').val('');
                // $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    // $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('.size-chart button').on('click', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var $prodSizeChart = $('.size-chart-modal .modal-body');
        if ($prodSizeChart.is(':empty') || $('.product-set-detail').length) {
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'html',
                success: function (response) {
                    $prodSizeChart.html(JSON.parse(response).content);
                    $('#sizechart-modal').modal('show');
                    customerservice.init();
                },
                error: function () {
                    $('#sizechart-modal').remove();
                }
            });
        } else {
            $('#sizechart-modal').modal('show');
            customerservice.init();
        }
    });

    var $sizeChart = $('.size-chart-collapsible');
    $('body').on('click touchstart', function (e) {
        if ($('.size-chart').has(e.target).length <= 0) {
            $sizeChart.removeClass('active');
        }
    });

    wishlist.addToWishlist();
    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
};
